export default {
  
  en: {
    paymentTime: 'Loan date',
    loanCount: 'Number of loans',
    newLoanCount: 'New cust number of loans',
    jianjunNew: 'New cust loan amount per',
    oldLoanCount: 'Old cust number of loans',
    jianjunOld: 'Old cust loan amount per',
    noRate: 'Proportion of old customers',
    paymentAmt: 'Loan principal',
    newPaymentAmt: 'New cust loan principal',
    oldPaymentAmt: 'Old cust loan principal',
    applyAmt: 'Apply Amount',
    newApplyAmt: 'New cust apply Amount',
    oldApplyAmt: 'Old cust apply Amount'
  },
  es: {
    title: 'Order Management'
  }
}
